import { useState, useEffect } from "react";

export default function Testimonials() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      quote:
        "Expert partners committed to working together to ensure the ideal result for the company and the individual.",
      author: "Sheik Rashmi",
      // role: "Human Resources Manager, BMW Group",
      image: "/images/test4.avif",
    },
    {
      quote:
        "Ampstek’s recruitment support has minimized the time I spend looking for candidates, allowing me to concentrate on interviewing and overseeing our tech responsibilities.",
      author: "Mahalakshmi",
      // role: "CTO",
      image: "/images/test8.jpg",
    },
    {
      quote:
      "Our experience with Ampstek has been excellent. The team is professional, quick to respond, and a pleasure to collaborate with. Working together has felt effortless.",
      author: "Priya",
      // role: "Global Talent Partner",
      image: "/images/test1.jpg",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const testimonial = testimonials[currentTestimonial];

  return (
    <section className="testimonials-section relative overflow-hidden">
      {/* <div className="testimonials-wave testimonials-wave--top" />
      <div className="testimonials-wave testimonials-wave--bottom" />
      <div className="testimonials-scribble testimonials-scribble--left" />
      <div className="testimonials-scribble testimonials-scribble--right" /> */}

      <div className="max-w-7xl mx-auto relative z-10 px-4 py-16 py-md-20 py-lg-24">
        <div className="row g-4 g-lg-5 align-items-center">
          <div className="col-12 col-lg-6 testimonials-copy text-white text-center text-lg-start">
            <span className="testimonials-quote-icon testimonials-quote-icon--open">❝</span>
            <blockquote
              key={testimonial.author}
              className="testimonials-quote mb-6 mb-md-8"
            >
              {testimonial.quote}
            </blockquote>
            <span className="testimonials-quote-icon testimonials-quote-icon--close">❞</span>
            <div className="testimonials-author">
              <p className="font-bold text-base text-md-lg mb-1">- {testimonial.author}</p>
              <p className="text-cyan-200 text-sm text-md-base">{testimonial.role}</p>
            </div>
          </div>
          <div className="col-12 col-lg-6 testimonials-visual">
            <div className="testimonials-card">
              <div className="testimonials-card-blob testimonials-card-blob--cyan" />
              <div className="testimonials-card-blob testimonials-card-blob--pink" />
              <img
                key={testimonial.author}
                src={testimonial.image}
                alt={testimonial.author}
                className="testimonials-card-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
